import styled from "styled-components";

const steps = [
  {
    label: 'Details',
    step: 1,
  },
  {
    label: 'Payment',
    step: 2,
  },
  {
    label: 'Confirmation',
    step: 3,
  }
]

const ProgressSteps = ({activeStep}) => {

  const totalSteps = steps.length;
  const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`

  return (
    <MainContainer>
      <StepContainer width={width}>
        {steps.map(({step, label}) => (
          <StepWrapper key={step}>
            <StepStyle step={activeStep === step ? 'current' : activeStep > step ? "completed" : "incomplete"}>
              {activeStep > step ? (
                <CheckMark>L</CheckMark>
              ) : (
                <StepCount
                  step={activeStep === step ? 'current' : activeStep > step ? "completed" : "incomplete"}>{step}</StepCount>
              )}
            </StepStyle>
            <StepsLabelContainer>
              <StepLabel key={step}
                         step={activeStep === step ? 'current' : activeStep > step ? "completed" : "incomplete"}>{label}</StepLabel>
            </StepsLabelContainer>
          </StepWrapper>
        ))}
      </StepContainer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
    width: 100%;
    max-width: 350px;
    padding: 0 16px;
    margin-bottom: 40px;
`

const StepContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        background: #E4E4E4;
        height: 6px;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
    }

    &:after {
        content: '';
        position: absolute;
        background: #00838F;
        height: 6px;
        width: ${({width}) => width};
        top: 50%;
        transition: 0.4s ease;
        transform: translateY(-50%);
        left: 0;
    }
`

const StepWrapper = styled.div`
    position: relative;
    z-index: 1;
`

const StepStyle = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({step}) => (step === 'current' ? '#FFFFFF' : step === 'completed' ? '#00838F' : '#FFFFFF')};
    border: 3px solid ${({step}) => (step === 'current' ? '#00838F' : step === 'completed' ? '#00838F' : '#828282')};
    transition: 0.4s ease;
    display: flex;
    justify-content: center;
    align-items: center;
`

const StepCount = styled.span`
    font-size: 12px;
    color: ${({step}) => (step === 'current' ? '#00838F' : step === 'completed' ? '#FFFFFF' : '#828282')};
`

const StepsLabelContainer = styled.div`
    position: absolute;
    top: 35px;
    left: 50%;
    transform: translate(-50%, -50%);
`

const StepLabel = styled.span`
    font-size: 13px;
    font-weight: bold;
    color: ${({step}) => (step === 'current' ? '#00838F' : step === 'completed' ? '#00838F' : '#828282')};
`

const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0 -15px;
    margin-top: 100px;
`

const ButtonStyle = styled.button`
    border-radius: 4px;
    border: 0;
    background: #4a154b;
    color: #ffffff;
    cursor: pointer;
    padding: 8px;
    width: 90px;

    :active {
        transform: scale(0.98);
    }

    :disabled {
        background: #f3e7f3;
        color: #000000;
        cursor: not-allowed;
    }
`

const CheckMark = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
    -ms-transform: scaleX(-1) rotate(-46deg); /* IE 9 */
    -webkit-transform: scaleX(-1) rotate(-46deg); /* Chrome, Safari, Opera */
    transform: scaleX(-1) rotate(-46deg);
`

const MainLabel = styled.div`
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    margin-top: 20px;
`

export default ProgressSteps